import { isNumber } from '@/src/tools/helper';
import React from 'react';
import {
  Form,
  OriNumberInput,
  RadioGroup,
  RadioItem,
} from 'src/components/Antd';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { replaceI18nVariables } from 'src/tools/tools';
// import { ESubscriptionBuyType } from 'src/types/common/discount';
// import { get } from 'lodash';
/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2023-05-10 15:41:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/RecurrenceRange/index.tsx
 */
const Item = Form.Item;
const ItemShouldUpdate = Form.ShouldUpdate;

export enum Recurrence {
  NoEndDate = 'NoEndDate',
  EndAfter = 'EndAfter',
}

function RecurrenceRange({
  recurrenceName,
  recurrenceRadioName,
  getRecurrenceRadioName,
  disableEdit,
  isUpFront,
}: any) {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <Item name={recurrenceRadioName}>
      <RadioGroup className={css.radioGroup} disabled={disableEdit}>
        {!isUpFront && (
          <div className={css.radioItemContainer}>
            <RadioItem value={Recurrence.NoEndDate} className={css.radioItem}>
              {getI18n('salesChannelSubscriptionBuy.frequency.noEndDate')}
            </RadioItem>
          </div>
        )}

        <div className={css.radioItemContainer}>
          <RadioItem value={Recurrence.EndAfter} className={css.radioItem}>
            {getI18n('salesChannelSubscriptionBuy.frequency.endAfter')}
          </RadioItem>
          <ItemShouldUpdate
            dependencies={[recurrenceRadioName]}
            childGenerate={({ getFieldValue, getFieldsValue }) => {
              const isDisplay =
                getFieldValue(getRecurrenceRadioName) === Recurrence.EndAfter;
              return (
                <Item
                  className={css.numberInput}
                  name={recurrenceName}
                  rules={[
                    {
                      validator: async (x, value) => {
                        if (!isNumber(value)) {
                          return Promise.reject(
                            new Error(getI18n('general.pleasefillthisfield')),
                          );
                        }
                        if (value <= 0 && isDisplay) {
                          return Promise.reject(
                            new Error(
                              replaceI18nVariables(
                                getI18n('general.valueshouldbegreaterthan'),
                                0,
                              ),
                            ),
                          );
                        }
                      },
                    },
                  ]}>
                  <OriNumberInput
                    size='large'
                    suffix={getI18n(
                      'salesChannelSubscriptionBuy.frequency.occurrences',
                    )}
                    disabled={!isDisplay || disableEdit}
                    min={0}
                  />
                </Item>
              );
            }}
          />
        </div>
      </RadioGroup>
    </Item>
  );
}

export default RecurrenceRange;
